import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";

import classes from "./bulkSpareLotListItemDetailPage.module.css";

import {
  useGetBulkSpareLotByIdQuery,
  useUpdateBulkSpareLotItemMutation,
} from "../../../../services/bulk/spares/bulkSpareLotListApiSlice";

import { BulkSpareLotItemDetailForm } from "../../../../component/bulk/bulkSpares/bulkSpareLotItemDetail/BulkSpareLotItemDetail";
import { toast } from "react-toastify";

export const BulkSpareLotListItemDetailPage = () => {
  const { request_id, item_id } = useParams();

  const { data: bulkSpareData, isFetching } = useGetBulkSpareLotByIdQuery({
    request_id,
    itemId: item_id,
  });

  const [updateBulkSpareLotItem, { isLoading }] =
    useUpdateBulkSpareLotItemMutation();

  const initialValues = useMemo(() => {
    if (!bulkSpareData?.data) return null;
    return { ...bulkSpareData.data };
  }, [bulkSpareData]);

  const handleSubmit = useCallback(
    async (formData) => {
      const payload = {
        description: formData.description,
        condition: formData.condition,
        quantity: String(formData.quantity),
        price: String(formData.price),
        retail_price_per_piece: String(formData.retail_price_per_piece),
      };
      const toastId = toast.loading("Updating Item...");

      try {
        await updateBulkSpareLotItem({
          request_id,
          itemId: item_id,
          data: payload,
        }).unwrap();

        toast.update(toastId, {
          render: "Item updated successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } catch (error) {
        console.error("Update failed:", error);

        const errorMessage =
          error?.data?.message ||
          error?.data?.error ||
          "Something went wrong. Please try again.";

        toast.update(toastId, {
          render: errorMessage,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      }
    },
    [request_id, item_id, updateBulkSpareLotItem],
  );

  if (isFetching || !initialValues) return null;
  // ideally replace with skeleton loader

  return (
    <div className={classes.box}>
      <BulkSpareLotItemDetailForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        isSubmitting={isLoading} // disable submit button inside form
      />
    </div>
  );
};
